import { KYMW2700Component } from './kymw2700.component';
import { PlessViewUtilsSub } from '../../../commons/kymw00/pless-view-utils-sub.service';

/**
 * 基版コピー・フェーズ管理画面の値を管理するクラス
 *
 * @export KYMW2700Model
 * @class KYMW2700Model
 */
export class KYMW2700Model {

  kymw2700Component: KYMW2700Component;

  // 画面バインド用変数
  public orderCode: string = <string>'';                                        // 受注コード
  public mediumType: string = <string>'';                                       // 媒体区分
  public progressWorkNum: string = <string>'';                                  // 確定フェーズコード
  public fixationPhaseList: Array<any> = new Array<any>();                      // 確定フェーズコンボボックス情報リスト

  public phaseCode: string = <string>'';                                        // フェーズコード
  public phaseName: string = <string>'';                                        // フェーズ名

  public fixationLockRelease: boolean = <boolean>false;                         // 確定ボタンロック解除

  public confirmFlag: string = <string>'0';                                     // 自動コマ配置実施確認フラグ(0：未確認、1：確認済)

  public dtgKihanCopyListEditable: boolean = <boolean>false;                    // 基版コピーグリッド編集可能フラグ

  public kihanCopyList: Array<any> = new Array<any>();                          // 基版コピーリスト

  public lockedResultFlag: string = <string>'';                                 // 排他情報・ロック処理結果フラグ
  public lockedOrderCode: string = <string>'';                                  // 排他情報・受注コード
  public lockedMidiumTypeCode: string = <string>'';                             // 排他情報・媒体区分

  public chkFixationLockEnableMode: boolean = <boolean>false;                   // 確定ボタンロック解除チェックボックス活性状態制御用
  public chkFixationLockSelectedMode: boolean = <boolean>false;                 // 確定ボタンロック解除チェックボックス選択状態制御用

  public chkPhaseSkipLockFlag: boolean = <boolean>false;                        // フェーズスキップロック解除フラグ

  public forcedPhaseFixationFlag: boolean = <boolean>false;                     // 媒体フェーズ同一の確認有無フラグ
  public commitDataBaseFlag: boolean = <boolean>false;                          // フェーズ確定DBcommitフラグ

  public isFirstFlg: boolean = <boolean>false;                                   // フェーズ確定初回フラグ

  // 「一括開始」・「一括コピー」の中、どのボタンからのイベント発生なのかを保持(KihanCopy：基版コピー、KihanRecopy：再コピー)
  public batchBiginingFlag: string = <string>'';
  public cntLimit = Number(0);
  public carrot = Number(0);

  //　表示モードのラジオボタン
  public rdb_DisplayMode: string = <string>'1';

  public allKihanCopyCheck: boolean = <boolean>false;
  public kihanCopyCheckedList: Array<any> = new Array<any>();

  // 活性制御用
  public cmbFixationPhaseDisabled: boolean = <boolean>false;
  public chkAllKihanCopyDisabled: boolean = <boolean>false;
  public chkKihanCopyDisabled: boolean = <boolean>false;

  /**
   * 確定フェーズコンボボックスデータを更新する
   *
   * @param {*} serverData APIレスポンス
   * @memberof KYMW2700Model
   */
  public initFixationPhaseCombo(serverData: any): void {
    let tempDataList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempDataList = serverData;

      if (PlessViewUtilsSub.isEmptyArray(tempDataList)) {
        tempDataList = new Array<any>();
      }
    }

    // 処理件数
    let index: number = <number>0;

    // 先頭空白追加
    tempDataList.splice(index, 0, this.getBlankObject('', ''));
    index = 1;

    // コード + ： + 名称追加
    for (; index < tempDataList.length; index++) {
      tempDataList[index].CodeValue =
        [PlessViewUtilsSub.trim(tempDataList[index].CodeValue)];
      tempDataList[index].CodeValueName =
        [PlessViewUtilsSub.trim(tempDataList[index].CodeValue) + ':' + PlessViewUtilsSub.trim(tempDataList[index].CodeName)];
    }

    this.fixationPhaseList = tempDataList;
  }

  /**
   * 空白のオブジェクトを取得する
   *
   * @private
   * @param {string} codeValue コード値
   * @param {string} codeName コード名
   * @returns {*}
   * @memberof KYMW2700Model
   */
  private getBlankObject(codeValue: string, codeName: string): any {
    const ob: any = {};
    ob.CodeDiv = '';
    ob.CodeValue = [codeValue];
    ob.CodeName = [codeName];
    ob.CodeDivName = '';
    ob.CodeValueName = '';
    ob.Reserve1 = '';
    ob.Reserve2 = '';
    ob.ReserveNum1 = '';
    ob.ReserveNum2 = '';
    ob.SortNum = '';
    ob.StartOrderCode = '';
    ob.EndOrderCode = '';

    return ob;
  }

  /**
   * 基版コピー一覧データを更新する
   *
   * @param serverData 基版コピー一覧取得データ
   */
  public updateCopyList(serverData: any): void {
    let tempkihanCopyList: Array<any> = new Array<any>();

    if (serverData !== null) {
      tempkihanCopyList = serverData.KihanCopyList;

      if (PlessViewUtilsSub.isEmptyArray(tempkihanCopyList)) {
        tempkihanCopyList = new Array<any>();
      }
    }

    // 基版コピー一覧データ設定
    this.kihanCopyList = tempkihanCopyList;
  }

  /**
   * 現在フェーズデータを更新
   *
   * @param {*} serverData 現在フェーズ取得データ
   * @memberof KYMW2700Model
   */
  public updateKihanPhase(serverData: any): void {
    this.phaseCode = PlessViewUtilsSub.trim(serverData.PhaseCode);           // 現在フェーズコード
    this.phaseName = serverData.PhaseName;                                   // 現在フェーズ名
  }

  /**
   * 現在フェーズデータをNULL更新する
   *
   * @memberof KYMW2700Model
   */
  public updateKihanCopyListAndPhaseByNull(): void {
    // 基版コピー一覧データ設定
    this.kihanCopyList = new Array<any>();
    // 現在フェーズコード設定
    this.phaseCode = null;
    // 現在フェーズ名設定
    this.phaseName = null;
  }

  /**
   * 現在基版コピーリストのデータを差し替える。
   *
   * @param {Array<any>} rs 基版コピーリスト
   * @returns {void}
   * @memberof KYMW2700Model
   */
  public updateKihanCopyList(rs: Array<any>): void {
    if (PlessViewUtilsSub.isEmptyArray(this.kihanCopyList)) {
      return;
    }

    for (let i = Number(0); i < this.kihanCopyList.length; i++) {
      const obj: any = this.kihanCopyList[i];

      for (let j = Number(0); j < rs.length; j++) {
        const obj2: any = rs[j];

        if (obj.PageNum === obj2.PageNum
        && obj.DiverFromCoopCode === obj2.DiverFromCoopCode) {
          // DataGridのスクロール移動を防ぐため、挿入後削除する。
          this.kihanCopyList.splice(i, 0, obj2);
          this.kihanCopyList.splice(i + 1, 1);
          
          // コピーリストから更新されたページ情報を削除
          for (let k = Number(0); k < this.kihanCopyCheckedList.length; k++) {
            if ( obj2.PageNum === this.kihanCopyCheckedList[k].PageNum ){
              this.kihanCopyCheckedList.splice(0, 1, obj2)
              if ( obj2.KihanCopy === this.kihanCopyCheckedList[k].KihanCopy ){
                this.kihanCopyCheckedList.splice(0, 1);
                return;
              }
            }
          }
        }
      }
    }
  }

}
